export default function EmptyHeader() {
  return (
    <div className="desktop-header">
      <img src={"/images/logo-black-font.svg"} />
    </div>
  );
}
